// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__evTIt","author":"Table_author__1ESiF","authorImage":"Table_authorImage__1choG","unreadRow":"Table_unreadRow__2ffxX"};